import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Col, message, Row, Spin } from 'antd';
import MessageConfirmModal from '../messageModal/MessageConfirmModal';
import InputComponent from '../input/InputComponent';
import {useNavigate, useParams } from 'react-router-dom';
import { GALLERY_URL, PRODUCT_CATEGORY_URL, PRODUCT_URL } from '../../api/URLs';
import { getDataRequest, postDataRequest, putDataRequest } from '../../api/serviceMethods';
import SelectComponent from '../select/SelectComponent';
import DragUploadComponent from '../upload/DragUploadComponent';
import TextAreaComponent from '../input/TextAreaComponent';
import HeaderCreateStaffComponent from '../header/HeaderCreateStaffComponent';
import OSSUploadWrapper from '../upload/OSSUploadWrapper';
import SelectTagsMultipleComponent from '../select/SelectTagsMultipleComponent';

function NewAvantGarde() {
    const { newStep } = useParams();
    const { t } = useTranslation();
    const { id } = useParams(); 
    const messageModalRef = useRef("");
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false)
    const [category, setCategory] = useState([])
    const [dataObject, setDataObject] = useState({
        images: [{ // multiple images
            url: "",
            size: "",
            name: ""
        }],
        category: "", // product category _id
        description: "",
        tags: [],
        status: true 
    });
    const [picUrl, setpicUrl] = useState([])

    const fetchCategory = async () => {
        const datas = [
            { label: "男", value: "男" },
            { label: "女", value: "女" },
            { label: "前卫创意", value: "前卫创意" },
        ];

        setCategory(datas);
    };
    useEffect(() => {
        fetchCategory()
    }, [])

    const addNewValue = async (data) => {
        setDataObject(
            {
                ...data,
                category: data?.category ? data?.category : "", // product category _id
                description: data?.description ? data?.description : "",
                status: data.status || "",
                tags: data?.tags ? data?.tags : [],
            }
        )
        setpicUrl(data.images ?
            [
                {
                    name: data.images && data.images[0].name || "",
                    size: data.images && data.images[0].size || "",
                    url: data.images && data.images[0].url || "",
                }
            ]
            : [])
    }

    const getDetailById = async () => {
        try {
            setLoading(true);
            await getDataRequest(`${GALLERY_URL}/${id && id}`)
                .then((res) => {
                    if (res.status === 200) {
                        addNewValue(res.data)
                    } 
                    setLoading(false);
                })
                .catch((err) => {
                    console.log(err);
                    setLoading(false);
                });
        } catch (error) {
            setLoading(false);
            message.error('Server Error!');
        }
    }
    useEffect(() => {
        if (id && id) { getDetailById() }
    }, [newStep]);

    const checkError = () => {
        if (
            picUrl && picUrl.length === 0 ||
            !dataObject.category
        ) {
            return true
        }
        return false
    }
    const insertParams = () => {
        const productPayload = {
            images: picUrl && picUrl.length > 0 ? picUrl[0].url : "",
            images: picUrl && picUrl.length > 0 ? [{
                url: picUrl && picUrl.length > 0 ? picUrl[0].url : "",
                size: picUrl && picUrl.length > 0 ? picUrl[0].size : "",
                name: picUrl && picUrl.length > 0 ? picUrl[0].name : "",
            }] : "",
            category: dataObject.category, // product category _id
            description: dataObject?.description,
            tags: dataObject?.tags ? dataObject?.tags : [],
            status: dataObject.status
        }
        return productPayload
    }

    const hadleUpdateProduct = async (e) => {
        e.preventDefault();
        setIsSubmit(true);
        try {
            const productPayload = insertParams()
            if (checkError()) {
                return false;
            }
            setLoading(true);
            await putDataRequest(`${GALLERY_URL}/${id && id} `, productPayload)
                .then((res) => {
                    if (res.status === 200) {
                        setLoading(false);
                        messageModalRef.current.showSuccessConfirmsAutoClose(t(res && t(res.message)), () => { }, "", true);
                        setTimeout(() => {
                            navigate("/avant-garde")
                        }, 2000);
                    } else {
                        messageModalRef.current.showWarningConfirmsAutoClose(res && t(res.message), () => { }, "", true);
                    }
                    setLoading(false);
                })
                .catch((err) => {
                    setLoading(false);
                    messageModalRef.current.showWarningConfirmsAutoClose(err && err.response && err.response.data && err.response.data.message || t("Server Error!"), () => { }, "", true);
                });
        } catch (error) {
            console.log("error", error)
            setLoading(false);
            message.error(t('Server Error!'));
        }
    }

    // Save member
    const handleSubmit = async () => {
        setIsSubmit(true)
        if (checkError()) {
            return false
        }
        setLoading(true);
        const productPayload = insertParams()
        try {
            const res = await postDataRequest(GALLERY_URL, productPayload);
            if (res?.status === 200) {
                messageModalRef.current.showSuccessConfirmsAutoClose(t(res && res.data?.message) || t("Saved Successfully"), () => { }, "", true);
                setTimeout(() => {
                    navigate("/avant-garde")
                }, 2000);
            } else {
                messageModalRef.current.showWarningConfirmsAutoClose(res && res.data?.message || res.message || t("An error occurred."), () => { }, "", true);
            }
        } catch (err) {
            messageModalRef.current.showWarningConfirmsAutoClose(err && err.response && err.response.data && err.response.data.message || "Server Error!", () => { }, "", true);
        } finally {
            setLoading(false);
            setIsSubmit(false);
        }
    }

    return (
        <>
            <HeaderCreateStaffComponent
                bntTitle={<>
                    <Button
                        className='b-danger'
                        disabled={loading}
                        type="primary"
                        onClick={id ? hadleUpdateProduct : handleSubmit}
                        style={{
                            fontSize: '16px',
                            backgroundColor: "#E50A47",
                            border: "1px solid #e72158",
                            color: "#FFFFFF",
                            opacity: loading ? '0.4' : ""
                        }}
                        danger
                    >
                        {id ? t("Submit") : t(`Submit`)}
                    </Button>
                </>}
                isHide="view"
                onClick={() => {
                    navigate('/avant-garde')
                }}
                backTitle={t('Create Gallery')}
            >
                <Spin spinning={loading}>
                    {
                        !newStep || newStep - 0 === 1 ? <div className='container newDetail'>
                            <Row className='mb-5'>
                                <Col md={4}>{t("Photo")} :</Col>
                                <Col md={20}>
                                    <Row className='w-100'>
                                        <Col md={24} sm={24}>
                                            <div className='w-100'>
                                                <OSSUploadWrapper
                                                    onUploadSuccess={(value) => {
                                                        setpicUrl([value]);
                                                    }}
                                                >
                                                    <DragUploadComponent
                                                        fileList={picUrl ? picUrl : []}
                                                        setFileList={(values) => {
                                                            setpicUrl(values)
                                                        }}
                                                    />
                                                </OSSUploadWrapper>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row className='mt-4 d-flex align-items-center'>
                                <Col md={4}>{t("Type")} :</Col>
                                <Col md={20}>
                                    <SelectComponent
                                        options={category}
                                        value={dataObject.category}
                                        setValue={(value) => setDataObject((v) => ({ ...v, category: value }))}
                                        status={isSubmit && !dataObject.category && "error"}
                                        placeholder=""
                                    />

                                </Col>
                            </Row>
                            <Row align="middle" className='mt-3'>
                                <Col md={4}>{t('Description')}:</Col>
                                <Col md={20} className="text-capitalize">
                                    <TextAreaComponent value={dataObject.description} setValue={(value) => setDataObject({ ...dataObject, description: value })} />
                                </Col>
                            </Row>
                            <Row className='mt-4 d-flex align-items-center'>
                                <Col md={4}>{t("Label")} :</Col>
                                <Col md={20}>
                                    <SelectTagsMultipleComponent
                                        options={[]}
                                        value={dataObject.tags}
                                        setValue={(value) => setDataObject((v) => ({ ...v, tags: value }))}
                                        status={isSubmit && !dataObject.category && "error"}
                                        placeholder=""
                                    />

                                </Col>
                            </Row>
                        </div>
                            :
                            ""
                    }
                    <MessageConfirmModal textCentered ref={messageModalRef} />
                </Spin>
            </HeaderCreateStaffComponent>
        </>
    );
}

export default NewAvantGarde;
